import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeTeamsApi from '../../../api/employeeTeamsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'employeeTeams';

export const GetEmployeeTeams = createAsyncThunk(`${REDUCER_NAME}/getEmployeeTeams`, async (__, thunkAPI) => {
  const res = await employeeTeamsApi.getV2({});

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const UpdateEmployeeTeam = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateEmployeeTeam`,
  async (updateTeamRequest, thunkAPI) => {
    const res = await employeeTeamsApi.updateV2(updateTeamRequest);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(res.data);
  }
);

export const updateEmployeeTeamWorkingOnCigar = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateWorkingOnCigar`,
  async ({ teamId, workOnCigarNew }, thunkAPI) => {
    const res = await employeeTeamsApi.updateTeamWorkingOnCigar({ id: teamId, workOnCigar: workOnCigarNew });

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(res?.data ?? { status: 'error', message: 'Failed to update work on cigar' });
  }
);

export const DeleteEmployeeTeam = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/deleteEmployeeTeam`,
  async (id, thunkAPI) => {
    const res = await employeeTeamsApi.deleteV2(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(res?.data ?? { status: 'error', message: 'Failed to delete employee team' });
  }
);

export const BulkDeleteEmployeeTeam = createAsyncThunk<any, string[]>(
  `${REDUCER_NAME}/bulkDeleteEmployeeTeam`,
  async (ids, thunkAPI) => {
    const res = await employeeTeamsApi.bulkDeleteV2(ids);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(res?.data ?? { status: 'error', message: 'Failed to delete employee teams' });
  }
);
